<template>
	<div class="modal-data-acao-auto">
		<v-dialog v-model="dialog" @input="cancel" width="500">
			<v-card>
				<v-card-title>Baixa de Pagamento</v-card-title>
				
				<v-card-text>
					<v-form ref="form" v-model="valid" lazy-validation>
						<v-col cols="12">
							<v-text-field
								outlined
								label="Data do Pagamento"
								type="date"
								v-model="dataPagamento"
								:rules="required"
							></v-text-field>
						</v-col>

						<v-col cols="12">
							<v-text-field
								outlined
								label="Valor do Pagamento"
								placeholder="120,00"
								type="text"
								v-model="valorPagamento"
								v-money="money"
								:rules="valorPagamentoRules"
								:prefix="currency"
							></v-text-field>
						</v-col>
					</v-form>
				</v-card-text>

				<v-card-actions>
					<v-btn
						class="ml-6 mb-4"
						color="primary"
						@click.prevent="confirm({dataPagamento: dataPagamento, valorPagamento: valorPagamento})"
					>Salvar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
	import { VMoney } from 'v-money';

	export default {
		name: "ModalBaixaPagamento",
		directives: {money: VMoney},

		data() {
			return {
				currency: "R$",
				money: {
					decimal: ",",
					thousands: ".",
					prefix: "",
					suffix: "",
					precision: 2,
					masked: false /* Não funciona com diretiva */
				},
				required: [(v) => !!v || "Este Campo é Obrigatório"],
				valorPagamentoRules: [
					v => !!v || 'Este Campo é Obrigatório',
					v => /^\$?[\d.]+(\,\d*)?$/.test(v) || 'Valor inválido',
				],
				valid: true,
				dataPagamento: null,
				valorPagamento: null,
				resolve: null,
				reject: null,
				dialog: false,
			};
		},

		computed: {
			//
		},

		methods: {
			open() {
				return new Promise((resolve, reject) => {
					this.dialog = true;
					this.resolve = resolve;
					this.reject = reject;
				});
			},

			cancel() {
				this.reject();
				this.close();
			},

			confirm(dadosPagamento) {
				if (!this.$refs.form.validate()) return;
				this.resolve(dadosPagamento);
				this.close();
			},

			close() {
				this.$refs.form.reset();
				this.dialog = false;
			},
		},
	};
</script>